import { ActivityIndicator, StyleProp, ViewStyle } from "react-native";

import { TextColor, colors } from "../theme";

type Props = {
  color?: TextColor;
  em?: boolean;
  large?: boolean;
  style?: StyleProp<ViewStyle>;
};

export function Spinner({
  color: colorName,
  em = false,
  large = false,
  ...rest
}: Props) {
  const color = colors[colorName ?? (em ? "accent" : "onSurface")];

  return (
    <ActivityIndicator
      {...rest}
      color={color}
      size={large ? "large" : "small"}
    />
  );
}
